import React from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import BookOverview from "./BookOverview";
import ProgressTracker from "./ProgressTracker";
import ProgressTrackerPlaceholder from "./ProgressTrackerPlaceholder";
import { fetchBookDetails } from "../redux/actions";
import { database } from "../firebase.config";
import history from "../router/history";

import Button from "@material-ui/core/Button";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: { color: "red" },
    buttonContainer: { textAlign: "center" },
  })
);

export default function BookReadingPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const readingList = useSelector((state) => state.readingList);
  const auth = useSelector((state) => state.auth);
  const bookId = props.match.params.bookId;
  const bookDetails = useSelector((state) => state.bookDetails);

  React.useEffect(() => {
    dispatch(fetchBookDetails(bookId));
  }, [bookId, dispatch]);

  const removeFromReadingList = async () => {
    history.push("/");

    await database
      .collection("users")
      .doc(auth.uid)
      .collection("ReadingList")
      .doc(bookId)
      .delete();
  };

  if (
    auth &&
    auth.uid &&
    readingList &&
    readingList[bookId] &&
    _.keys(readingList).length > 0
  ) {
    return (
      <>
        <BookOverview
          key={bookId}
          id={bookId}
          title={readingList[bookId].title}
          authors={readingList[bookId].authors}
          publisher={readingList[bookId].publisher}
          description={readingList[bookId].description}
          cover={readingList[bookId].cover}
          rating={readingList[bookId].rating ? readingList[bookId].rating : 0}
        />
        {bookDetails && bookDetails.id ? (
          <ProgressTracker bookId={bookId} />
        ) : (
          <ProgressTrackerPlaceholder />
        )}
        <div className={classes.buttonContainer}>
          <Button
            className={classes.button}
            startIcon={<DeleteIcon />}
            onClick={removeFromReadingList}
          >
            Remove From Reading List
          </Button>
        </div>
      </>
    );
  } else {
    return null;
  }
}
